import Vue from "vue";
import {
  ObterProtocolos,
  ObterTiposSolicitacao,
  DetalheProtocolo,
  UploadArquivo,
  RetornoPendencia,
  ObterImagem,
  ObterDocumento
} from "@/api/programasSaude";

const initialState = {
  protocolos: [],
  lastFetch: null,
  tipos: [],
  detalhe: null,
  carregando: false,
  erro: null,
  newSolicitation: {},
  successRequest: false
};

export default {
  namespaced: true,
  state: () => ({ ...initialState }),
  actions: {
    async fetchProtocolos(context, { force } = {}) {
      if (!force && context.state.lastFetch) return;
      Vue.set(context.state, "carregando", true);
      try {
        const resp = await ObterProtocolos({ vinculo: context.rootState.saude.vinculo });
        const data = Array.isArray(resp?.Data) ? resp.Data : Array.isArray(resp) ? resp : [];
        const protocols = data.map(p => ({
          protocol: p.ProtocoloANS,
          ticket: p.Chamado,
          title: p.TipoSolicitacao,
          createdAt: p.DtSolicitacao,
          statusCode: p.CdSituacao,
          statusDsc: p.DsSituacao,
          beneficiaryName: p.DsSolicitante,
          beneficiaryCode: p.CdSolicitante,
          documentId: p.Documento ?? 0
        }));
        context.commit("SET_PROTOCOLOS", protocols);
        return data;
      } finally {
        Vue.set(context.state, "carregando", false);
      }
    },

    async fetchTiposSolicitacao(context) {
      Vue.set(context.state, "carregando", true);
      try {
        const resp = await ObterTiposSolicitacao({ vinculo: context.rootState.saude.vinculo });
        const data = Array.isArray(resp?.Data) ? resp.Data : Array.isArray(resp) ? resp : [];
        context.commit("SET_TIPOS", data);
        return data;
      } finally {
        Vue.set(context.state, "carregando", false);
      }
    },

    async fetchDetalheProtocolo(context, { protocolo }) {
      Vue.set(context.state, "carregando", true);
      try {
        const resp = await DetalheProtocolo({ vinculo: context.rootState.saude.vinculo, protocolo });
        if (resp) {
          context.commit("SET_DETALHE", resp);
          return resp;
        }
        return null;
      } finally {
        Vue.set(context.state, "carregando", false);
      }
    },

    async uploadArquivo(context, { formData }) {
      return await UploadArquivo({ vinculo: context.rootState.saude.vinculo, formData });
    },

    async enviarRetornoPendencia(context, { protocolo, observacao, arquivos }) {
      return await RetornoPendencia({
        vinculo: context.rootState.saude.vinculo,
        protocolo,
        observacao,
        arquivos
      });
    },

    async fetchProtocolDetailImage(context, { documento, original = false }) {
      return await ObterImagem({ vinculo: context.rootState.saude.vinculo, documento, original });
    },

    async getDocumentUrl(context, { protocolo }) {
      return await ObterDocumento({ vinculo: context.rootState.saude.vinculo, protocolo });
    },

    async RESET_CONTEXT({ commit }) {
      commit("RESET_STATE");
    },

    async LOGOUT_USER({ commit }) {
      commit("RESET_STATE");
    }
  },
  mutations: {
    SET_PROTOCOLOS(state, protocolos) {
      Vue.set(state, "lastFetch", new Date().getTime());
      Vue.set(state, "protocolos", protocolos);
    },
    SET_TIPOS(state, tipos) {
      Vue.set(state, "tipos", tipos);
    },
    SET_DETALHE(state, detalhe) {
      Vue.set(state, "detalhe", detalhe);
    },
    SET_NEW_SOLICITATION(state, payload) {
      Vue.set(state, "newSolicitation", {
        ...state.newSolicitation,
        ...payload
      });
    },
    SET_SUCCESS_REQUEST(state, flag) {
      Vue.set(state, "successRequest", flag);
    },
    RESET_STATE(state) {
      Object.keys(initialState).forEach(k => Vue.set(state, k, initialState[k]));
    }
  },
  getters: {
    listaProtocolos: s => s.protocolos,
    tiposSolicitacao: s => s.tipos,
    detalheAtual: s => s.detalhe,
    estaCarregando: s => s.carregando,
    newSolicitation: s => s.newSolicitation,
    successRequest: s => s.successRequest
  }
};
